import { render, staticRenderFns } from "./KassaSummary.vue?vue&type=template&id=7cbebd83"
import script from "./KassaSummary.vue?vue&type=script&lang=js"
export * from "./KassaSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports